<template>

  <div id="excelEditorSection" ref="excelEditorSection" class="row">
<!--    <input type="file" @change="handleFile"/>-->


    <div class="table-wrapper"
         :style="{
       '--ct-sticky-top': stickyHeaderTop + 'px',
       '--ct-sticky-bottom': stickyScrollbarBottom + 'px'
     }"
    >
    <div
        class="table-responsive custom-scrollbar table-section table-scroll"
        ref="tableScroll"
        style="height: 100vh;"
    >
<!--       STICKY TOP SCROLLBAR -->
      <div v-if="showTopHorizontalScrollbar" class="sticky-hscroll sticky-hscroll-top custom-scrollbar"
           ref="stickyHScrollTop"
           @scroll="syncScrollFromStickyTop"
      >
        <div class="sticky-hscroll-inner" :style="{ width: tableScrollWidth + 'px' }"></div>
      </div>

    <vue-excel-editor ref="excelEditor" id="excelEditor" v-model="jsondata" :localized-label="myLabels" :key="headers"
                      auto-fill-width
                      :filter-row="false"
                      :showFilterMethods="false"
                      :disablePanelFilter="true"
                      :noSorting="true"
                      :noHeaderEdit="true"
                      @cell-click="onCellClick"
                      @cell-dbclick="onCellDbClick"
                      @cell-focus="onCellFocus"
                      @cell-blur="onCellBlur"
                      @page-changed="onPageChanged"
                      @select="onSelectRow"
                      @mass-clear-select="onMassClearSelect"
                      @un-select="onUnSelect"
                      @cell-update="onCellUpdate"
                      @sort="onSort"
                      @on-context-menu="openContextMenu"
                      @first-row-focus="onFirstRowReach"
                      @last-row-focus="onLastRowReach"
                      :page="200"
                      :readonly="isPublished"
                      :row-style="rowStyle"
                      :cell-style="cellStyle"
                      :col-style="colStyle"
                      :readonlyStyle="isPublished === true ? {backgroundColor: '#f5f5f5', color: '#808080'} : {backgroundColor: '#f8f8f8'}"
                      :no-footer="false"
                      :enable-native-mouse-scrolling="true"
                      :enable-column-groups="true"
                      :column-groups="columnGroups"
                      @column-group-action="onColumnGroupAction"
                      grouped-columns-default-placement="end"

    >
      <vue-excel-column v-for="header in headers" :key="header" :field="header.key" :label="header.text"
                        :type="header.type" :width="header.width"
                        :options="header.options"
                        :readonly="!!header.readonly"
                        :autocomplete="true"
                        :auto-fill-width="false"
                        :sticky="false"
                        @select="onSelect"

      />
      <template #table-header>
        <slot name="generator-table-header"></slot>
      </template>
    </vue-excel-editor>

    </div>

      <!-- STICKY BOTTOM SCROLLBAR -->
      <div  v-if="showBottomHorizontalScrollbar" class="sticky-hscroll sticky-hscroll-bottom custom-scrollbar"
           ref="stickyHScrollBottom"
           @scroll="syncScrollFromStickyBottom"
      >
        <div class="sticky-hscroll-inner" :style="{ width: tableScrollWidth + 'px' }"></div>
      </div>

    </div>


  </div>

</template>

<script>
import * as XLSX from "xlsx";
import {writeFileXLSX} from "xlsx";
import VueExcelEditor from "@/components/widgets/vue3-excel-editor-mp/src/VueExcelEditor.vue";
import VueExcelColumn from "@/components/widgets/vue3-excel-editor-mp/src/VueExcelColumn.vue";

export default {
  name: "PackageOrdersGeneratorTable",
  props: {
    data: Array,
    headers: Array,
    isPublished: {
      type: Boolean,
      default: false
    },
    rowStyle: {
      type: Function, default() {
        return {}
      }
    },
    cellStyle: {
      type: Function, default() {
        return {}
      }
    },
    colStyle: {
      type: Function, default() {
        return {}
      }
    },
    stickyHeaderTop: { type: Number, default: 0 },
    stickyScrollbarBottom: { type: Number, default: 0 },
    showBottomHorizontalScrollbar: { type: Boolean, default: true },
    showTopHorizontalScrollbar: { type: Boolean, default: false },
    columnGroups: { type: Array, default: () => [] }
  },
  emits:['cell-click','cell-focus', 'cell-blur', 'page-changed', 'select-row', 'mass-clear-select', 'un-select','enter', 'cell-update', 'sort','cell-dbclick','on-context-menu',
  'first-row-reached', 'last-row-reached'],
  components: {
    VueExcelEditor, VueExcelColumn
  },
  data() {
    return {

      jsondata: [],
      myLabels: {
        footerLeft: (top, bottom, total) => `Rekordy od ${top} do ${bottom} z ${total}`,
        first: 'Pierwszy',
        previous: 'Poprzedni',
        next: 'Następny',
        last: 'Ostatni',
        footerRight: {
          selected: 'Zaznaczone:',
          filtered: 'Przefiltrowane:',
          loaded: 'Załadowane:'
        },
        processing: 'Przetwarzanie',
        tableSetting: 'Ustawienia tabeli',
        exportExcel: 'Eksportuj do Excel',
        importExcel: 'Importuj z Excel',
        back: 'Powrót',
        reset: 'Domyślne',
        sortingAndFiltering: 'Sortowanie i filtrowanie',
        sortAscending: 'Sortuj rosnąco',
        sortDescending: 'Sortuj malejąco',
        near: '≒ Zbliżone',
        exactMatch: '= Dokładne dopasowanie',
        notMatch: '≠ Nie pasuje',
        greaterThan: '&gt; Większe niż',
        greaterThanOrEqualTo: '≥ Większe lub równe',
        lessThan: '&lt; Mniejsze niż',
        lessThanOrEqualTo: '≤ Mniejsze lub równe',
        regularExpression: '~ Wyrażenie regularne',
        customFilter: 'Filtr niestandardowy',
        listFirstNValuesOnly: n => `Pokaż tylko pierwsze ${n} wartości`,
        apply: 'Zastosuj',
        noRecordIsRead: 'Nie wczytano żadnego rekordu',
        readonlyColumnDetected: 'Wykryto kolumnę tylko do odczytu',
        columnHasValidationError: (name, err) => `Kolumna ${name} zawiera błąd walidacji: ${err}`,
        noMatchedColumnName: 'Nie znaleziono pasującej nazwy kolumny',
        invalidInputValue: 'Nieprawidłowa wartość wejściowa',
        missingKeyColumn: 'Brak kolumny klucza',
        noRecordIndicator: 'Brak rekordów'
      },
      showColumnManager:false,
      visibleHeaders:[],
      visibleHeaderKeys:[],
      tableScrollWidth: 0,
      isSyncingScroll: false,


    }

  },
  computed: {
    showDeleteAction() {
      // return this.$refs.excelEditor.selectedCount > 0  // Show if any records selected
      return true
    },
    showSendEmailInvitationAction() {
      // return this.$refs.excelEditor.selectedCount === 1  // Show if single record is selected
      return true
    },
    showSendBirthdayGreetingAction() {
      // // Show only if any selected people birthday matched today
      // var today = new Date().toISOString().slice(0, 10);
      // if (this.$refs.excelEditor.selectedCount > 0) {
      //   return this.$refs.excelEditor.getSelectedRecords().filter(item => item.birth === today).length > 0
      // } else {
      //   return false
      // }
      return true
    },
    hasValidColumnGroups() {
      return Array.isArray(this.columnGroups) && this.columnGroups.length > 0
    }
  },
  methods: {
    onColumnGroupAction(payload) {
      this.$emit('column-group-action', payload)
    },
    updateTableScrollWidth() {
      const tableEl = this.$refs.excelEditor ? this.$refs.excelEditor.$refs.systable : null;
      if (!tableEl) return;
      // scrollWidth = realna szerokość tabeli (wraz z “wyjechaniem” poza ekran)
      this.tableScrollWidth = tableEl.offsetWidth || 0;
    },

    syncScrollFromTable() {
      if (this.isSyncingScroll) return;

      const tableContent = this.$refs.excelEditor ? this.$refs.excelEditor.$refs.tableContent : null;
      const stickyTop = this.$refs.stickyHScrollTop;
      const stickyBottom = this.$refs.stickyHScrollBottom;
      if (!tableContent) return;

      this.isSyncingScroll = true;
      const scrollLeft = tableContent.scrollLeft;
      if (stickyTop) stickyTop.scrollLeft = scrollLeft;
      if (stickyBottom) stickyBottom.scrollLeft = scrollLeft;
      requestAnimationFrame(() => (this.isSyncingScroll = false));
    },

    syncScrollFromStickyTop() {
      if (this.isSyncingScroll) return;
      const tableContent = this.$refs.excelEditor ? this.$refs.excelEditor.$refs.tableContent : null;
      const stickyTop = this.$refs.stickyHScrollTop;
      const stickyBottom = this.$refs.stickyHScrollBottom;
      if (!tableContent || !stickyTop) return;

      this.isSyncingScroll = true;
      const scrollLeft = stickyTop.scrollLeft;
      tableContent.scrollLeft = scrollLeft;
      if (stickyBottom) stickyBottom.scrollLeft = scrollLeft;
      requestAnimationFrame(() => (this.isSyncingScroll = false));
    },

    syncScrollFromStickyBottom() {
      if (this.isSyncingScroll) return;
      const tableContent = this.$refs.excelEditor ? this.$refs.excelEditor.$refs.tableContent : null;
      const stickyTop = this.$refs.stickyHScrollTop;
      const stickyBottom = this.$refs.stickyHScrollBottom;
      if (!tableContent || !stickyBottom) return;

      this.isSyncingScroll = true;
      const scrollLeft = stickyBottom.scrollLeft;
      tableContent.scrollLeft = scrollLeft;
      if (stickyTop) stickyTop.scrollLeft = scrollLeft;
      requestAnimationFrame(() => (this.isSyncingScroll = false));
    },

    exportAsExcel() {
      const format = 'xlsx'
      const exportSelectedOnly = true
      const filename = 'test'
      this.$refs.excelEditor.exportTable(format, exportSelectedOnly, filename)
    },
    exportAsCsv() {
      const format = 'csv'
      const exportSelectedOnly = true
      const filename = 'test'
      this.$refs.excelEditor.exportTable(format, exportSelectedOnly, filename)
    },


    onSelect(selectedRows) {
      console.log(selectedRows)
    },
    onCellClick(event){
      this.$emit('cell-click',event);
    },
    onCellDbClick(event){
      this.$emit('cell-dbclick',event);
    },
    onCellFocus(event){
      this.$emit('cell-focus',event);
    },
    onCellBlur(event){
      this.$emit('cell-blur',event);
    },
    onPageChanged(event) {
      this.$emit('page-changed', event);
    },
    onSelectRow(event) {
      this.$emit('select-row', event);
    },
    onMassClearSelect(event) {
      this.$emit('mass-clear-select', event);
    },

    onUnSelect(event) {
      this.$emit('un-select', event);
    },
    onCellUpdate(event) {
      console.log("Cell updated event:", event);
      this.$emit('cell-update', event);
    },
    onSort(event) {
      this.$emit('sort', event);
    },
    openContextMenu(event) {
      console.log("Context menu event:", event);
      this.$emit('on-context-menu', event);
    },
    onFirstRowReach(event) {
      this.$emit('first-row-reached', event);
    },
    onLastRowReach(event) {
      this.$emit('last-row-reached', event);
    },
    handleFile(event) {
      const file = event.target.files[0];

      if (file) {
        this.readExcel(file);
      }
    }
    ,
    readExcel(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, {type: 'binary'});

        // Extract data from the workbook (e.g., first sheet)
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Convert the worksheet data to JSON (or your preferred format)
        const json = XLSX.utils.sheet_to_json(worksheet);

        // Update your data model (e.g., using v-model in vue-excel-editor)
        this.jsondata = json; // Assuming 'jsondata' is your data model
      };

      reader.readAsBinaryString(file);
    }
    ,
    exportFile() {
      /* generate worksheet from state */
      const ws = XLSX.utils.json_to_sheet(this.jsondata);
      /* create workbook and append worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Data");
      /* export to XLSX */
      writeFileXLSX(wb, "SheetJSVueAoO.xls");
    }
    ,
  }
  ,
  created() {
  },
  mounted() {
    console.log("Excel editor refs:", this.$refs.excelEditor ? this.$refs.excelEditor.$refs.systable : null)

    this.jsondata = JSON.parse(JSON.stringify(this.data));
    this.$nextTick(() => {
      this.updateTableScrollWidth();

      // obserwuj zmiany rozmiaru tabeli (kolumny widoczne/ukryte, dane, resize okna)
      const tableEl = this.$refs.excelEditor ? this.$refs.excelEditor.$refs.systable : null;
      if (tableEl && window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.updateTableScrollWidth());
        this.resizeObserver.observe(tableEl);
      }

      const tableContent = this.$refs.excelEditor ? this.$refs.excelEditor.$refs.tableContent : null;
      if (tableContent) {
        tableContent.addEventListener("scroll", this.syncScrollFromTable, { passive: true });
      }

      window.addEventListener("resize", this.updateTableScrollWidth, { passive: true });
    });
  },

  beforeUnmount() {
    const tableContent = this.$refs.excelEditor ? this.$refs.excelEditor.$refs.tableContent : null;
    if (tableContent) {
      tableContent.removeEventListener("scroll", this.syncScrollFromTable);
    }
    window.removeEventListener("resize", this.updateTableScrollWidth);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

}
</script>

<style scoped>
.table-wrapper{
  position: relative;
  --ct-sticky-top: 0px;
  --ct-sticky-bottom: 0px;
}

.table-scroll::-webkit-scrollbar:horizontal {
  height: 0 !important;
}
.table-scroll {
  scrollbar-gutter: stable; /* opcjonalnie */
}
.table-scroll {
  scrollbar-width: none;      /* Firefox (ukryje też pionowy) */
  -ms-overflow-style: none;   /* stary Edge/IE */
}
.table-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* sticky poziomy pasek */
.sticky-hscroll{
  position: sticky;
  height: 14px;             /* “grubość” paska */
  overflow-x: auto;
  overflow-y: hidden;
  background: #fff;
  z-index: 50;
}

.sticky-hscroll-top {
  top: var(--ct-sticky-top, 0px);
  border-bottom: 1px solid #dee2e6;
  /* margin-bottom: -14px; */ /* Usuwamy negatywny margines, żeby pasek nie nakładał się na nagłówek */
}

.sticky-hscroll-bottom {
  bottom: var(--ct-sticky-bottom, 0px);
  border-top: 1px solid #dee2e6;
  /* margin-top: -14px; */
}

/* “sztuczna” zawartość, żeby pojawił się scrollbar */
.sticky-hscroll-inner{
  height: 1px;
}

/* Custom Scrollbar for the table container */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #ced4da; /* Bootstrap Gray-400 */
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #adb5bd; /* Bootstrap Gray-500 */
}
.custom-scrollbar::-webkit-scrollbar {
  width: 12px; /* Nieco szerszy dla wygody */
  height: 12px; /* Wysokość poziomego paska */
}
</style>
